import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { DocumentMutationIdentifier } from '@utils/types/editors/transcripts/api.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export function useClearTextDocument() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ sessionId, documentId }: DocumentMutationIdentifier) => {
      return await Axios.put(PUT_URL(sessionId, documentId).clearTextDocument);
    },
    {
      onSuccess: async (_, request) => {
        await queryClient.invalidateQueries(
          QueryKeys.document(request.sessionId, request.documentId)
        );

        await queryClient.invalidateQueries(
          QueryKeys.session(request.sessionId)
        );

        window.location.reload();
      }
    }
  );
}
